import { render, staticRenderFns } from "./NoStripes.vue?vue&type=template&id=4ce3972f&scoped=true&"
import script from "./NoStripes.vue?vue&type=script&lang=ts&"
export * from "./NoStripes.vue?vue&type=script&lang=ts&"
import style0 from "./NoStripes.vue?vue&type=style&index=0&id=4ce3972f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3972f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
